import { render, staticRenderFns } from "./_purgeLeagueLog.vue?vue&type=template&id=6cf49174&scoped=true&lang=pug&"
import script from "./_purgeLeagueLog.vue?vue&type=script&lang=js&"
export * from "./_purgeLeagueLog.vue?vue&type=script&lang=js&"
import style0 from "./_purgeLeagueLog.vue?vue&type=style&index=0&id=6cf49174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf49174",
  null
  
)

export default component.exports